import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";

// Instant-screen query helper. Cached data renders immediately (no loader),
// and a quiet background refresh keeps it fresh. Use `q.data ?? fallback`
// and only show a loader when `q.isLoading` (true just for the first fetch
// with no cache available).
export function useApiQuery(key, path, options = {}) {
  const enabled = options.enabled !== undefined ? options.enabled : !!path;
  return useQuery({
    queryKey: Array.isArray(key) ? key : [key],
    queryFn: () => api(path),
    enabled,
    ...options,
  });
}

export { useQueryClient };
